module.exports = __webpack_public_path__ + "img/banner2.69866bc0.jpg";